import { isAgent, pushEvent } from "./pushEvent";

export function pushSelectFlightEvent({flight, currency}: {flight: any, currency: string}) {

  if(isAgent()) return;

  if(!Array.isArray(flight?.fares) || flight.fares.length === 0) return;

  const fare = flight.fares[0];
  const fareInfo = fare?.fareInfos[0];
  if(!fareInfo) return;

  const item = {
    item_id: `Fare-${fare.fareTypeID}-${fareInfo.fareID}`,
    item_name: `${fare.fareTypeName}`,
    item_category: 'flight',
    fare_class_code: fareInfo.fareClassCode,
    fare_basis_code: fareInfo.fareBasisCode,
    fare_amount: fareInfo.fareAmt,
    price: fareInfo.fareWithTaxes,
    quantity: 1,
    currency: currency,
  }

  const data = {
    // item_list_id: `${flight.carrierCode}${flight.flightNumber}@${flight.departureDate}`,
    item_list_name: `Flight Fares`,
    origin: flight.originCode,
    destination: flight.destinationCode,
    departure_date: flight.departureDate,
    arrival_date: flight.arrivalDate,
    carrier_code: flight.carrierCode,
    flight_number: flight.flightNumber,
    items: [item]
  }

  pushEvent({ event: 'select_item', data})
}